import React, { lazy, Suspense, startTransition } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import "./components/CSSTransition.css";
import Navbar from "./components/Navbar";
import ScrollToTopButton from "./components/ScrollToTopButton";
import Galleries from "./components/Galleries";
import Projects from "./components/Projects";
import Trainings from "./components/Trainings";

const About = lazy(() => import("./components/About"));
const News = lazy(() => import("./components/News"));
const Contact = lazy(() => import("./components/Contact"));
const OurTeam = lazy(() => import("./components/OurTeam"));
const Catering = lazy(() => import("./components/Classes/Catering"));
const Sewing = lazy(() => import("./components/Classes/Sewing"));
const IT = lazy(() => import("./components/Classes/IT"));
const Electrical = lazy(() => import("./components/Classes/Electrical"));
const Cosmetology = lazy(() => import("./components/Classes/Cosmetology"));
const FabricDesign = lazy(() => import("./components/Classes/FabricDesign"));
const Crafting = lazy(() => import("./components/Classes/Crafting"));
const EventPlanning = lazy(() => import("./components/Classes/EventPlanning"));
const ScrollToTop = lazy(() => import("./components/ScrollToTop"));
const Main = lazy(() => import("./components/Main"));
const AdminNewsUpload = lazy(() => import("./components/AdminNewsUpload"));

function App() {
  return (
    <div>
      <Navbar />
      <Suspense
        fallback={
          <div className="flex items-center justify-center min-h-screen">
            <div className="text-xl">Loading...</div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/about" element={<About />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/our-team" element={<OurTeam />} />
          <Route path="/galleries" element={<Galleries />} />
          <Route path="/projects/galleries/catering" element={<Catering />} />
          <Route path="/projects/galleries/sewing" element={<Sewing />} />
          <Route path="/projects/galleries/it" element={<IT />} />
          <Route path="/projects/galleries/electrical" element={<Electrical />} />
          <Route path="/projects/galleries/cosmetology" element={<Cosmetology />} />
          <Route path="/projects/galleries/fabric-design" element={<FabricDesign />} />
          <Route path="/projects/galleries/crafting" element={<Crafting />} />
          <Route path="/projects/galleries/event-planning" element={<EventPlanning />} />
          <Route path="/projects/galleries" element={<Galleries />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/trainings" element={<Trainings />} />
          {/* Secret admin route - Do not link in navbar or public pages */}
          <Route path="/admin-content-manager" element={<AdminNewsUpload />} />
        </Routes>
      </Suspense>
      <ScrollToTop />
      <ScrollToTopButton />
    </div>
  );
}

export default App;
